export enum PortCallPdaLineStatuses {
  CALCULATED = 'calculated',
  MISSING_DATA = 'missing_data',
  MANUAL = 'manual',
}
